import React from 'react';

import { NoticeLayer } from '../components/social-media-forwarding/NoticeLayer';
import type { FeatureAppState, NoticeText } from '../types';
import { getCountrySelectionPageUrl } from './getCountrySelectionPageUrl';
import { getHostName } from './getHostName';

export function createNotificationContent(
  featureAppState?: FeatureAppState,
  onContentLinkClicked?: () => void,
) {
  const noticeLayerTexts: NoticeText[] = [];

  if (featureAppState?.translations) {
    noticeLayerTexts.push({
      language: featureAppState.primaryLanguage,
      countrySite: getHostName(),
      otherSitesLinkCaption: featureAppState.translations.otherSitesLinkCaption,
      noticeText: featureAppState.translations.noticeText,
      otherSitesLinkUrl: getCountrySelectionPageUrl(),
    });
  }

  if (featureAppState?.fallbackTranslations) {
    noticeLayerTexts.push({
      language: featureAppState.fallbackLanguage,
      countrySite: getHostName(),
      otherSitesLinkCaption: featureAppState.fallbackTranslations.otherSitesLinkCaption,
      noticeText: featureAppState.fallbackTranslations.noticeText,
      otherSitesLinkUrl: getCountrySelectionPageUrl(),
    });
  }

  return <NoticeLayer texts={noticeLayerTexts} onContentLinkClicked={onContentLinkClicked} />;
}
